module.exports = __webpack_public_path__ + "static/media/img_snake_body_horizontal.c61818ed.svg";